'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
    _react2.default.createElement(_reactRouter.Route, { path: '/funds/:fundId/:investmentVehicleId/:ticker', component: _containers.FundRedirect }),
    _react2.default.createElement(_reactRouter.Route, { path: '/funds/:fundId/:investmentVehicleId', component: _containers.FundRedirect }),
    _react2.default.createElement(_reactRouter.Route, { path: '/fund/:name/:ticker/fossil-fuel-investments/:fundId/:investmentVehicleId', component: _containers.FundFossilFuelInvestments }),
    _react2.default.createElement(_reactRouter.Route, { path: '/fund/:name/:ticker/carbon-footprint/:fundId/:investmentVehicleId', component: _containers.FundCarbonFootprint }),
    _react2.default.createElement(_reactRouter.Route, { path: '/fund/:name/:ticker/fossil-finance-insurance/:fundId/:investmentVehicleId', component: _containers.FundFossilFinanceInvestments }),
    _react2.default.createElement(_reactRouter.Route, { path: '/fund/:name/:ticker/clean200-investments/:fundId/:investmentVehicleId', component: _containers.FundCleanEnergyInvestments }),
    _react2.default.createElement(_reactRouter.Route, { path: '/fund/:name/:ticker/investment-profile/:fundId/:investmentVehicleId', component: _containers.FundInvestmentProfile }),
    _react2.default.createElement(_reactRouter.Route, { path: '/funds', component: _containers.List }),
    _react2.default.createElement(_reactRouter.Route, { path: '/compare', component: _containers.Compare }),
    _react2.default.createElement(_reactRouter.Route, { path: '/families', component: _containers.Family }),
    _react2.default.createElement(_reactRouter.Route, { path: '/thrift-savings-plan', component: _containers.TspLanding }),
    _react2.default.createElement(_reactRouter.Route, { path: '/about', component: _containers.About }),
    _react2.default.createElement(_reactRouter.Route, { path: '/how-it-works', component: _containers.HowItWorks }),
    _react2.default.createElement(_reactRouter.Route, { path: '/fossil-fuel-companies', component: _containers.FossilFuelCompanies }),
    _react2.default.createElement(_reactRouter.Route, { path: '/video-tutorials', component: _containers.VideoTutorials }),
    _react2.default.createElement(_reactRouter.Route, { path: '/carbon-underground-200', component: _containers.CarbonUnderground200 }),
    _react2.default.createElement(_reactRouter.Route, { path: '/banks-insurance', component: _containers.AboutBanksInsurance }),
    _react2.default.createElement(_reactRouter.Route, { path: '/macroclimate-50', component: _containers.Macroclimate50 }),
    _react2.default.createElement(_reactRouter.Route, { path: '/morningstar', component: _containers.Morningstar }),
    _react2.default.createElement(_reactRouter.Route, { path: '/carbon-footprint', component: _containers.CarbonFootprint }),
    _react2.default.createElement(_reactRouter.Route, { path: '/clean-200', component: _containers.Clean200 }),
    _react2.default.createElement(_reactRouter.Route, { path: '/fossil-free-action-toolkit', component: _containers.Toolkit }),
    _react2.default.createElement(_reactRouter.Route, { path: '/media', component: _containers.Media }),
    _react2.default.createElement(_reactRouter.Route, { path: '/legal', component: _containers.Legal }),
    _react2.default.createElement(_reactRouter.Route, { path: '/resources', component: _containers.Resources }),
    _react2.default.createElement(_reactRouter.Route, { path: '/index-funds', component: _containers.IndexFunds }),
    _react2.default.createElement(_reactRouter.Route, { path: '/target-date-funds', component: _containers.TargetDateSeries }),
    _react2.default.createElement(_reactRouter.Route, { path: '/sign-up', component: _containers.Signup }),
    _react2.default.createElement(_reactRouter.Route, { path: '/thrift-savings-plan-toolkit', component: _containers.TspToolkit }),
    _react2.default.createElement(_reactRouter.Route, { path: '/macroclimate-30', component: _containers.Redirect }),
    _react2.default.createElement(_reactRouter.Route, { path: '/university-retirement-plans-funding-destruction-students-future', component: _containers.Redirect }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1481
// module chunks = 0